import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import room from './modules/room'
import trade from './modules/trade'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    room,
    trade
  }
})
